import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { RecalProposalSetProvider } from "presentation/store/RecalProposalSet/RecalProposalSetProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import RecalProposalSetMaintenance from "presentation/view/section/RecalProposalSet/RecalProposalSetMaintenance";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const RecalProposalSetContMain = () => {
    return <ANAInfoWrapper permission={Permission.RECAL_PROPOSAL_SET_MAINTENANCE}>
        <MessageBarWrapper>
            <RecalProposalSetProvider>
                <GridStyles/>
                <RecalProposalSetMaintenance/>
            </RecalProposalSetProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default RecalProposalSetContMain;